import React from 'react';
import { Card } from '../../components/ui/card';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = ({ testimonials }) => (
  <section className="py-20 md:py-24 bg-white" id="testimonials" data-testid="testimonials-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-2xl md:text-3xl font-display font-semibold text-tp-text mb-4">Ce que nos clients disent</h2>
        <p className="text-tp-text-light max-w-2xl mx-auto">Ils nous font confiance pour renforcer leurs équipes</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((t) => (
          <Card key={t.name} className="p-6 border-tp-border hover:shadow-lg transition-all relative" data-testid={`testimonial-${t.name}`}>
            <Quote className="h-8 w-8 text-tp-primary/20 absolute top-4 right-4" />
            <div className="flex items-center gap-1 mb-4">
              {[...Array(t.rating)].map((_, i) => (
                <Star key={`star-${t.name}-${i}`} className="h-4 w-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <p className="text-tp-text-light mb-6 leading-relaxed">"{t.content}"</p>
            <div className="flex items-center gap-3 pt-4 border-t border-tp-border">
              <div className="w-10 h-10 rounded-full bg-tp-accent/10 flex items-center justify-center">
                <span className="text-sm font-semibold text-tp-primary">{t.name.split(' ').map(n => n[0]).join('')}</span>
              </div>
              <div>
                <p className="font-medium text-tp-text text-sm">{t.name}</p>
                <p className="text-xs text-tp-text-light">{t.role}, {t.company}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
